<template>
  <v-container fluid class="py-2">
    <v-row>
      <v-col cols="12">
        <user-table @view-profile="onViewProfile"></user-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import UserTable from "./Widgets/UserTable.vue";

export default {
  name: "UserList",
  components: {
    UserTable,
  },
  methods: {
    onViewProfile(userId) {
      // Emit the event to parent component
      this.$emit("view-user", userId);
    },
  },
};
</script>
